import React, { useEffect } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";

import MainLayout from "../components/layout/MainLayout";
import Breadcrumbs from "../components/common/Breadcrumbs";
import DepotInjectionList from "./Phase-05/DepotInjectionChart/DepotInjectionList";
import { selectHasPermission } from "../store/slices/authSlice";
import {
    fetchDepotInjectionCharts,
    deleteDepotInjectionChart,
} from "../store/slices/depotInjectionChartsSlice";

const DepotInjections = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const canManage = useSelector((state) =>
        selectHasPermission(state, "depot-injections-manage")
    );
    const canCreate = useSelector((state) =>
        selectHasPermission(state, "depot-injections-create")
    );
    const canEdit = useSelector((state) =>
        selectHasPermission(state, "depot-injections-edit")
    );
    const canDelete = useSelector((state) =>
        selectHasPermission(state, "depot-injections-delete")
    );

    // Redux state
    const { depotInjectionCharts, isLoading, error } = useSelector(
        (state) => state.depotInjectionCharts
    );

    useEffect(() => {
        dispatch(fetchDepotInjectionCharts());
    }, [dispatch]);

    const handleAdd = () => navigate("/phase05/depot-injections/add");
    const handleEdit = (id) => navigate(`/phase05/depot-injections/edit/${id}`);

    const handleDelete = async (id) => {
        const result = await Swal.fire({
            title: "Are you sure?",
            text: "This record will be deleted permanently!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, delete it!",
        });

        if (result.isConfirmed) {
            try {
                await dispatch(deleteDepotInjectionChart(id)).unwrap();
                Swal.fire("Deleted!", "Record has been removed.", "success");
                dispatch(fetchDepotInjectionCharts()); // refresh list
            } catch (err) {
                Swal.fire("Error!", "Failed to delete the record.", "error");
            }
        }
    };

    if (!canManage)
        return (
            <Navigate
                to="/dashboard"
                state={{ error: "You do not have permission to manage Depot Injections." }}
                replace
            />
        );

    return (
        <MainLayout>
            <div className="container-xxl flex-grow-1 container-p-y">
                <Breadcrumbs />

                {error && (
                    <div className="alert alert-danger alert-dismissible fade show" role="alert">
                        <strong>Error:</strong> {error}
                    </div>
                )}

                <div className="card">
                    <div className="card-body">
                        {isLoading ? (
                            <div className="d-flex justify-content-center py-5">
                                <div className="spinner-border" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                            </div>
                        ) : (
                            <DepotInjectionList
                                records={depotInjectionCharts || []}
                                onAdd={canCreate ? handleAdd : null}
                                onEdit={canEdit ? handleEdit : null}
                                onDelete={canDelete ? handleDelete : null}
                            />
                        )}
                    </div>
                </div>
            </div>
        </MainLayout>
    );
};

export default DepotInjections;
